import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Kategoriler from "../pages/kategoriler/page";
import Sepet from "../pages/sepet/page";
import OzelTasarim from "../pages/ozel-tasarim/page";
import UrunDetay from "../pages/urun-detay/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/kategoriler",
    element: <Kategoriler />,
  },
  {
    path: "/urun/:slug",
    element: <UrunDetay />,
  },
  {
    path: "/sepet",
    element: <Sepet />,
  },
  {
    path: "/ozel-tasarim",
    element: <OzelTasarim />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;